exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".schedule {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: horizontal;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-flow: row wrap;\r\n          flex-flow: row wrap;\r\n  margin: 0;\r\n  padding: 0;\r\n  list-style: none;\r\n}\r\n\r\n.schedule__time {\r\n  display: inline-block;\r\n  width: 50px;\r\n  margin: 0px 4px;\r\n  color: rgba(255, 255, 255, 0.72);\r\n}\r\n\r\n.schedule__time--disabled {\r\n  color: rgba(255, 255, 255, 0.24)\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/shared/schedule/schedule.component.css
// module id = ../../../../../src/app/shared/schedule/schedule.component.css
// module chunks = 4